var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"col-6 col-lg-3 mb-5 pb-md-5 partenaire"},[_c('div',{staticClass:"partenaire-item",on:{"click":_vm.show}},[_c('img',{staticClass:"black-icons",attrs:{"src":_vm.getImageUrl(_vm.category)}}),_c('div',{staticClass:"partenaire-name"},[_vm._v(" "+_vm._s(_vm.category.getTitle(_vm.$l))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }